import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Checkbox, CheckboxProps } from 'tea-component';

type IHeatMapCheckboxProps = CheckboxProps;

const HeatMapCheckbox: React.FC<IHeatMapCheckboxProps> = (props) => {
  const { className, value, onChange, ...restProps } = props;

  const { formatMessage } = useIntl();

  return (
    <Checkbox
      {...restProps}
      className={classnames('dbi-common-checkbox dbi-heat-map-checkbox search-item', className)}
      display="inline"
      value={value}
      onChange={onChange}
    >
      {formatMessage({ id: 'dbi_compare_heat_map' })}
    </Checkbox>
  );
};

export default HeatMapCheckbox;
